import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule, MatProgressBarModule]
})
export class LoaderComponent implements OnInit {
  @Input() isMobile: boolean;
  public isLoading: boolean;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.loaderSubject.subscribe(data => {
      this.isLoading = data;
      console.debug('[LoaderComponent] render -> isLoading:', this.isLoading);
    });
  }
}
